// map the status text with the constants placed on the server
export function getMappedStatus(status) {
  if (status === "IN_PROGRESS") {
    return "In Progress";
  } else if (status === "OPEN") {
    return "Unopened";
  } else if (status === "ON_HOLD") {
    return "On Hold";
  } else if (status === "RESOLVED") {
    return "Resolved";
  } else if (status === "DOCTOR_ACTION_REQUIRED") {
    return "Doctor Action Required";
  } else if (status === "ADMIN_ACTION_REQUIRED") {
    return "Support Action Required";
  } else {
    return "Reopened";
  }
}

// return doctor info for table in one string
export function getDoctorInfoMapped(doctor) {
  let name = "UIN: " + doctor.doctorId + " | " + doctor.firstName.trim() + " ";

  if (doctor.middleName && doctor.middleName.trim().length > 0) {
    name = name + doctor.middleName + " ";
  }

  name = name + doctor.lastName;

  return name;
}

// return patient info for table in on string
export function getPatientInfoMapped(patient) {
  return (
    "UIN: " +
    patient.patientId +
    " | " +
    patient.firstName +
    " " +
    patient.lastName
  );
}

// Dynamic sort helper function
export function compareValues(key, order = "asc") {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}

// sort data being send on the basis of need and return new sorted instance of array
export function sortData(key, order, data) {
  return data.slice().sort(compareValues(key, order));
}

// read file data using file reader
export function getFileData(file) {
  let reader = new FileReader();

  reader.onload = function(e) {
    return e.target.result;
  };

  reader.readAsDataURL(file);
}

export function csUndefined(data) {
  //trim
  if (data) {
    data = data.toString().trim();
    //multiple spaces, tabs, newlines
    data = data.replace(/\r?\n|\r/g, " ");
    data = data.replace(/\s\s+/g, " ");
  }
  return data;
}

export function formatName(str) {
  let res = "";

  for (let i = 0; i < str.length; i++) {
    if (str[i] === "'" && i !== str.length) {
      res = res + str[i] + str[i + 1].toUpperCase();
      i++;
    } else if (str[i] === "-" && i !== str.length) {
      res = res + str[i] + str[i + 1].toUpperCase();
      i++;
    } else {
      res = res + str[i];
    }
  }

  return res;
}

export function checkEmptyElementInObj(obj) {
  const emptyKeyArray = [];
  if (!obj || typeof obj !== "object" || Object.keys(obj).length === 0)
    return emptyKeyArray;

  const objKeyValueArray = Object.entries(obj);
  objKeyValueArray.forEach(item => {
    if (typeof item[1] === "number" || typeof item[1] === "boolean") return;
    if (!item[1] || (typeof item[1] === "object" && item[1].length === 0)) {
      return emptyKeyArray.push(item[0]);
    }
    if (typeof item[1] === "object" && Object.keys(item[1]).length === 0) {
      return emptyKeyArray.push(item[0]);
    }
    if (!item[1]) emptyKeyArray.push(item[0]);
  });

  return emptyKeyArray;
}
